import { memo } from 'react'

import { IAccessibility } from 'clickNgo/models/widget'
import { InfoBlock, InfoBlockRounded, InfoBlockType } from 'cng-common/components/infoBlock'
import { RenderWhen } from 'cng-common/components/renderWhen'
import { FormMultiselect } from 'cng-common/features/form'
import { FieldWrapperWithChanges } from 'cng-common/features/form/components'
import { ValidationType } from 'cng-common/features/form/configs'
import { wasFieldModified } from 'cng-common/features/form/helpers'
import { FieldGroup } from 'shared/components/fieldGroup'

import { ContactFormContent } from '../../config/forms'
import { TContactFormKeys } from '../../model/forms'
import {
  IContactHPRolesFormHandlers,
  IContactHPRolesFormRequiredFields,
  IContactHPRolesFormValidation,
  THPRoles,
} from '../../model/forms/hpRoles'
import { IContact } from '../../model/types'

import { UNIQUE_ROLE_INFO } from './configs'
import { useHPRolesSource } from './hooks'

interface IProps
  extends IAccessibility,
    IContactHPRolesFormHandlers,
    IContactHPRolesFormValidation,
    IContactHPRolesFormRequiredFields {
  contact: IContact
  formKeys: TContactFormKeys
  isCollapsible?: boolean
  isCollapsed?: boolean
  validationType?: ValidationType
}

export const ContactHPRoles = memo<IProps>((props) => {
  const source = useHPRolesSource(props.contact)

  return (
    <FieldGroup
      title={ContactFormContent.titles.hpRoles}
      size={1}
      isCollapsible={props.isCollapsible}
      isCollapsed={props.isCollapsed}
    >
      <RenderWhen condition={!props.isReadOnly}>
        <InfoBlock
          text={UNIQUE_ROLE_INFO}
          type={InfoBlockType.Help}
          rounded={InfoBlockRounded.Medium}
        />
      </RenderWhen>
      <FieldWrapperWithChanges
        hasChanges={wasFieldModified(
          props.contact.modifiedValues,
          ContactFormContent.fields.hpRoles.field
        )}
        isHidden={!props.isReadOnly}
      >
        <FormMultiselect<THPRoles>
          formKey={props.formKeys.hpRoles}
          source={source}
          caption="title"
          defaultValue={props.contact.hpRoles}
          field={ContactFormContent.fields.hpRoles.field}
          label={ContactFormContent.fields.hpRoles.label}
          onChange={props.onHPRolesChange}
          onValidate={props.onHPRolesValidate}
          isRequired={props.isHPRolesRequired}
          isDisabled={props.isDisabled || props.isDisabledByRegion}
          isReadOnly={props.isReadOnly}
          validationType={props.validationType}
          isStatic
        />
      </FieldWrapperWithChanges>
    </FieldGroup>
  )
})

ContactHPRoles.displayName = 'ContactHPRoles'
